import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNumber',
  pure: false
})
export class FilterNumberPipe implements PipeTransform {
  transform(list:any, args:number, attr: Array<any>):any {
    if (!list) return false;

    var attrSplit: Array<string>;
    var item2: any;
    var tt: string;
    var filter: any;

    filter = list.filter(item => {
      if(!args) {
        return item;
      }

      for (let key in attr) {
        attrSplit = attr[key].split(".");
        item2 = item;

        for (let keyY in attrSplit) {
          tt = item2[attrSplit[keyY]];
          if (tt) {
            item2 = tt;
          }
        }

        if (item2 == args) {
          return item;
        }
      }
    });

    return filter ? filter : list;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/filter-number.pipe.ts
 **/